module.exports = __webpack_public_path__ + "img/8.0bbf8f94.png";